import { useState, useEffect, useRef } from 'react';
import './App.css';
import WelcomeBanner from './components/WelcomeBanner/WelcomeBanner';
import birdFlyGif from './assets/gifs/seaGull.gif';
import NewCanvas from './components/NewCanvas';
function App() {
  const [bubbleOpen, setBubbleOpen] = useState(true);
  const birdFlyRef = useRef(null)
  const keyPressHandler = (event) => {
    // changing the state to the name of the key
  // which is pressed
  // console.log(event.key);
};

useEffect(()=> {
  var lastRenderTime = 0;
  var flyingBirdLeftPos = 0;

  const flyingBirdLeftPosFun = () => {
    return Math.floor(Math.random() * 100)
  
  }
  // var dancingSnakeLeftPos = 0;
  const flyingBirdTopPos = () => {
  return Math.floor(Math.random() * 20)

}

function flyingBirdTopPosition() {
  
  var flyingBird = document.getElementsByClassName('flying-bird')
  if (flyingBirdLeftPos > 90) {
    flyingBirdLeftPos = flyingBirdLeftPosFun() * -1;
    var newTopPos = flyingBirdTopPos();
    var newLeftPos = flyingBirdLeftPos;
    flyingBird[0].style.top = `${newTopPos}%`;
    flyingBird[0].style.left = `${newLeftPos}%`;
  } else {
    let newLeft = (flyingBirdLeftPos += 0.22);
    // dancingSnake.style.left = newSpeed
    flyingBird[0].style.left = `${newLeft}%`;
  }
  
  // console.log(dancingSnake[0].style);
  // dancingSnake.addEventListener('clicked', ok);
  // console.log("hoiseeeee");
}
// dancingSnakeTopPosition()

function main(currentTime) {

  // highScoreRenderInScreen();
  flyingBirdTopPosition()

  window.requestAnimationFrame(main)
  const secondsSinceLastRender = (currentTime - lastRenderTime) / 1000
  if (secondsSinceLastRender < 1 / 2) return


  // lastRenderTime = currentTime

  // update()
  // draw()
}

window.requestAnimationFrame(main)

  
},[])



  return (
    <div className="App" onKeyDown={(e) => keyPressHandler(e)}>
      <WelcomeBanner />
      <img
        ref={birdFlyRef}
        src={birdFlyGif}
        alt="billBoard_garden"
        className="flying-bird"
        style={{ width: "100px", height: "50px" }}
      />
      <NewCanvas />
    </div>
  );
}

export default App;
